import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function buildQueryString(filters) {
  const params = new URLSearchParams();
  
  Object.keys(filters).forEach(key => {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== '') {
      if (typeof value === 'boolean') {
        params.append(key, value ? '1' : '0');
      } else {
        params.append(key, value);
      }
    }
  });
  
  return params.toString();
}

export async function getFinanzasDashboard(filters, apiBasePath = '/api/admin') {
  const query = buildQueryString(filters);
  const url = `${API_BASE_URL}${apiBasePath}/finanzas-dashboard?${query}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta información.');
  }

  if (res.status === 422) {
    const body = await res.json();
    const error = new Error(body?.message || 'Error de validación');
    error.status = 422;
    error.response = { data: body };
    throw error;
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar el dashboard de finanzas'}`);
  }

  return res.json();
}
